import SSOAJX4 from '.';
import { IRoute } from '../../utils/navigation/routes';

export const ssoRoutes: IRoute[] = [{ path: '/sso', element: <SSOAJX4 /> }];
